<mat-card>
  <mat-card-content class="flex flex-col gap-[20px]">
    <ng-container *ngIf="data.doNotAskAgain">
      <div>
        {{ '+INSTALLATIONS.INSTALLATION.OPERATING_MODE_IGNORED_INFORMATION' | translate }}
      </div>
      <div>
        <mat-checkbox [(ngModel)]="askAgain" (ngModelChange)="onChange($event)">
          {{ 'GENERAL.CHECKBOX.DO_NOT_ASK_AGAIN' | translate }}
        </mat-checkbox>
      </div>
    </ng-container>
    <div *ngIf="!data.doNotAskAgain">
      {{ '+INSTALLATIONS.INSTALLATION.HEATING_CURVE_IGNORED_INFORMATION' | translate }}
    </div>
  </mat-card-content>
  <mat-card-actions class="!flex flex-row gap-[8px] justify-end items-center">
    <button
      *ngIf="!data.doNotAskAgain"
      data-at-hc-ignored-cancel-btn
      mat-raised-button
      gtm="onCancelDialog"
      gtmCategory="heatingCurveConfirmationModal"
      color="primary"
      (click)="onCancel()"
    >
      {{ 'GENERAL.BUTTON.CANCEL' | translate }}
    </button>
    <button
      id="confirm-btn"
      data-at-hc-ignored-confirm-btn
      mat-raised-button
      gtm="onConfirm"
      gtmAction="Heating curve change"
      gtmCategory="heatingCurveConfirmationModal"
      color="primary"
      (click)="onConfirm()"
    >
      {{ 'GENERAL.BUTTON.UNDERSTOOD' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
